// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__dG8cc","label":"style_label__SCSMs"};